import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { siteConfig } from '../config/site';

export function HomePage() {
  return (
    <>
      <Seo
        title="Home"
        description="Essential home repairs for low-income families, creating safer and more stable homes."
      />
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-copy">
            <p className="eyebrow">Practical repairs. Lasting stability.</p>
            <h1>Home repairs that help families stay rooted.</h1>
            <p className="hero-lead">{siteConfig.shortDescription}</p>
            <div className="button-row">
              <Link className="button" to="/contact">Request help</Link>
              <Link className="text-link" to="/projects">See how we help <span aria-hidden="true">→</span></Link>
            </div>
          </div>
          <div className="hero-art" aria-label="A welcoming illustration of a safe home">
            <div className="home-illustration" aria-hidden="true">
              <div className="sun-shape" />
              <div className="house-shape">
                <div className="roof-shape" />
                <div className="window-shape" />
                <div className="door-shape" />
              </div>
              <div className="heart-badge">♥</div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container split-heading">
          <div>
            <p className="eyebrow">Why we exist</p>
            <h2>When repairs cannot wait, families should have somewhere to turn.</h2>
          </div>
          <div>
            <p>For families with limited incomes, a leaking roof, unsafe wiring, or broken furnace can quickly become a crisis. We help remove those hazards and protect the place they already call home.</p>
            <Link className="text-link" to="/about">Our story <span aria-hidden="true">→</span></Link>
          </div>
        </div>
      </section>

      <section className="section section-tinted" aria-labelledby="work-heading">
        <div className="container">
          <p className="eyebrow">What we do</p>
          <div className="section-heading-row">
            <h2 id="work-heading">Focused help for the problems that matter most.</h2>
            <Link className="text-link" to="/projects">View all work <span aria-hidden="true">→</span></Link>
          </div>
          <div className="card-grid">
            {[
              ['Critical home repairs', 'We address urgent health and safety needs, from roofing and plumbing to electrical and structural repairs.'],
              ['Accessibility updates', 'We make homes easier and safer to navigate with practical modifications based on each household’s needs.'],
              ['Weatherization', 'We improve comfort and energy efficiency through repairs that help keep homes warm, dry, and protected.'],
            ].map(
              ([title, description], index) => (
                <article className="feature-card" key={title}>
                  <span className="card-number" aria-hidden="true">0{index + 1}</span>
                  <h3>{title}</h3>
                  <p>{description}</p>
                </article>
              ),
            )}
          </div>
        </div>
      </section>

      <section className="section callout">
        <div className="container callout-inner">
          <div>
            <p className="eyebrow">Take part</p>
            <h2>Help a family feel safe at home.</h2>
          </div>
          <div>
            <p>Volunteer your skills, become a community partner, or support the materials and labor that make essential repairs possible.</p>
            <Link className="button button-light" to="/contact">Join the work</Link>
          </div>
        </div>
      </section>
    </>
  );
}
